module.exports = __webpack_public_path__ + "img/server-room.2eb5237f.png";